<script setup>
import LogoIDriveRental from '@/Components/LogoIDriveRentals.vue'
import NavigationMenu from '@/Components/NavigationMenu.vue'
import ButtonCta from '@/Components/ui/buttons/ButtonCta.vue'
import { goToAndScrollTo } from '@/Composables/common.js'
import { useAnnouncementSchedule } from '@/Composables/useAnnouncements.js'
import { Link } from '@inertiajs/vue3'
import { onMounted, onUnmounted, ref } from 'vue'

const { showAnnouncement } = useAnnouncementSchedule()

const showMobileMenu = ref(false)
const emit = defineEmits(['mobile-menu-toggled'])
const toggleMobileMenu = async () => {
	showMobileMenu.value = !showMobileMenu.value
	emit('mobile-menu-toggled', showMobileMenu.value)
}

const handleBookNow = async () => {
	await toggleMobileMenu()
	goToAndScrollTo('/', '#book-car')
}

const isHidden = ref(false)

const lastScrollPosition = ref(0)

const handleScroll = () => {
	const currentScrollPosition = window.scrollY

	if (
		currentScrollPosition > 50 &&
		currentScrollPosition > lastScrollPosition.value
	) {
		isHidden.value = true
	}
	// If scrolling up, show the header
	else if (currentScrollPosition < lastScrollPosition.value + 50) {
		isHidden.value = false
	}

	// Update the last scroll position for the next scroll event
	lastScrollPosition.value = currentScrollPosition
}

onMounted(() => {
	window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
	window.removeEventListener('scroll', handleScroll)
})
</script>

<template>
	<header
		class="relative z-[100] p-4 mb-8"
		:class="showAnnouncement ? 'mt-[60px]' : ''"
	>
		<div
			class="hidden md:flex flex-row w-full justify-between items-center"
		>
			<Link href="/">
				<LogoIDriveRental />
			</Link>

			<NavigationMenu class="hidden md:flex" />

			<div class="flex flex-row gap-3 items-center">
				<div class="hidden sm:block">
					<a
						target="_blank"
						href="https://www.instagram.com/idrive_rentals_au/"
					>
						<img
							src="/assets/img/ico-insta.png"
							width="24"
							height="24"
							alt="instagram"
						/>
					</a>
				</div>
				<div class="hidden sm:block">
					<a
						target="_blank"
						href="https://www.facebook.com/idriverentalsau"
					>
						<img
							src="/assets/img/ico-facebook.png"
							class=""
							height="24"
							width="24"
							alt="facebook"
						/>
					</a>
				</div>
				<ButtonCta @click="goToAndScrollTo('/', '#book-car')">
					<span class="font-bold">Book now</span>
				</ButtonCta>
			</div>
		</div>
		<!-- mobile header -->
		<div class="md:hidden py-4">
			<transition name="slide-fade">
				<div v-if="showMobileMenu" class="hamburger-bg">
					<div class="px-10 mt-[150px] flex flex-col gap-14">
						<NavigationMenu
							class="relative"
							:is-menu-active="showMobileMenu"
							@click="toggleMobileMenu"
						/>
						<div class="flex flex-col gap-8">
							<ButtonCta
								button-mode="dark"
								additional-classes="h-12 text-lg"
								@click="handleBookNow"
							>
								<span class="font-bold">Book now</span>
							</ButtonCta>
							<div
								class="flex flex-row gap-4 items-center justify-center"
							>
								<a
									target="_blank"
									href="https://www.instagram.com/idrive_rentals_au/"
								>
									<img
										src="/assets/img/ico-insta.png"
										width="24"
										height="24"
										alt="instagram"
									/>
								</a>
								<a
									target="_blank"
									href="https://www.facebook.com/idriverentalsau"
								>
									<img
										src="/assets/img/ico-facebook.png"
										class=""
										height="24"
										width="24"
										alt="facebook"
									/>
								</a>
							</div>
						</div>
					</div>
				</div>
			</transition>
			<div
				class="hamburger-header flex flex-row items-center justify-between w-full fixed top-0 left-0 p-4"
				:class="[
					isHidden && !showMobileMenu ? '__hide' : '__show',
					showMobileMenu ? '__nobg' : '',
					showAnnouncement ? 'mt-[60px]' : '',
				]"
			>
				<Link href="/">
					<LogoIDriveRental
						class="fixed"
						:is-menu-active="showMobileMenu"
					/>
				</Link>
				<button
					class="hamburger-toggle"
					:class="[showMobileMenu ? '__active' : '']"
					@click="toggleMobileMenu"
				>
					<div class="hamburger-bar" data-position="top"></div>
					<div class="hamburger-bar" data-position="bottom"></div>
				</button>
			</div>
		</div>
	</header>
</template>
